import * as Yup from "yup";
import dayjs from "dayjs";

export const industryCollaborationSchema = Yup.object().shape({
  partner_name: Yup.string().required("Partner name is required"),
  partner_industry: Yup.string().nullable(),
  project: Yup.string().nullable(),
  description: Yup.string().nullable(),
  institution_id: Yup.string().required("Institution is required"),
  date_started: Yup.string().nullable(),
  date_ended: Yup.string()
    .nullable()
    .test(
      "end-after-start",
      "End date must be after start date",
      function (value) {
        const { date_started } = this.parent;
        if (date_started && value) {
          return dayjs(value).isAfter(dayjs(date_started));
        }
        return true;
      }
    ),
});
